import { colsMedium } from "./WaypointsTableStyles";

export const WaypointsExpanded = ({ data, userPrefUnits, size, headerFontStyle }) => {
  const [paceUnit, distanceUnit, elevationUnit] = userPrefUnits;
  return (
      <div className='waypoint-chart-inner'>
        <div className='row'>
          <div className='waypoint-chart-inner-card'>
            <div style={headerFontStyle}>Time:</div> 
              {data.elapsedTime}
          </div>
          <div className='waypoint-chart-inner-card'>
            <div style={headerFontStyle}>Pace ({paceUnit}):</div> 
              {data.pace}
          </div>
          <div className='waypoint-chart-inner-card'>
            <div style={headerFontStyle}>Cumulated Climb ({elevationUnit}):</div> {data.cumAscent}
          </div>
          <div className='waypoint-chart-inner-card'>
            <div style={headerFontStyle}>Cumulated Descent ({elevationUnit}):</div> {data.cumDescent}
          </div>
        </div>
        <div className='row waypoint-chart-inner-title' style={headerFontStyle}>From previous waypoint</div>
        <div className='row'>
          <div className='waypoint-chart-inner-card'>
            <div style={headerFontStyle}>Time:</div> 
            {data.time}
          </div>
          <div className='waypoint-chart-inner-card'>
            <div style={headerFontStyle}>Distance ({distanceUnit}):</div> {data.distance_section}
          </div>
          {(size.width < colsMedium && <div className='waypoint-chart-inner-card'>
            <div style={headerFontStyle}>Elevation change ({elevationUnit}):</div> {data.elevChange}
          </div>)}
          <div className='waypoint-chart-inner-card'>
            <div style={headerFontStyle}>Grade change:</div> {data.gradeChange}
          </div>
        </div>
        <div className='waypoint-chart-inner-title'>
          <div style={headerFontStyle}>Notes:</div> {data.description}
        </div>
      </div>
    );
};